import cn from 'bem-cn';

import { DividerProps } from './Divider.types';
import './Divider.scss';

const b = cn('divider');

export const Divider = (props: DividerProps) => {
    const { className, orientation = 'horizontal' } = props;

    return <div className={b({ orientation }, [className])} />;
};
